<template>
    <div class="search-overlay" :class="{active: props.opened}" @click="close">
        <div class="search-overlay__bg"></div>
        <div class="search-overlay__content">
            <div class="search-overlay__content-grid">
                <div class="search-overlay__content-inner">
                    <div class="search-overlay__content-cell">
                        <div class="search-overlay-close"><button-close @click="close"/></div>
                        <h2 class="search-overlay-headline body-text">{{ $t("search.modal.headline") }}</h2>
                        <div @click.stop class="search-overlay-form">
                            <form ref="form" method="get" :action="props.formAction">
                                <div class="search-overlay-input">
                                    <input
                                        ref="formInput"
                                        autocomplete="off"
                                        @click="selector=null"
                                        @keyup="keyHandle"
                                        :placeholder="$t('search.modal.placeholder')"
                                        type="text"
                                        v-model="searchTerm"
                                        name="tx_kesearch_pi1[sword]"
                                    >
                                    <button class="mdc-button__icon-single">
                                        <span class="mdc-button__icon material-symbols-outlined">search</span>
                                    </button>
                                </div>
                                <input name="id" type="hidden" value="163">
                                <input name="no_cache" type="hidden" value="1">
                                <input name="tx_kesearch_pi1[page]" type="hidden" value="1">
                                <input name="tx_kesearch_pi1[resetFilters]" type="hidden" value="0">
                                <input name="tx_kesearch_pi1[sortByField]" type="hidden" value="">
                                <input name="tx_kesearch_pi1[sortByDir]" type="hidden" value="">
                                <input name="which_search" type="hidden" value="Header">
                            </form>
                            <ul @click.stop class="search-overlay__list" :class="{open: suggest.length}">
                                <li @click="selectSearch(s)" v-for="(s, i) in suggest" :class="{active: selector===i}">
                                    <span v-html="suggestLabel(s)"/>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {onMounted, ref, watch} from "vue";

export default {
    name: "search-overlay",
    props: {
        opened: {
            type: Boolean,
            required: true
        },
        formAction: {
            type: String,
            required: true
        }
    },
    setup(props, { emit }) {
        const searchTerm = ref("");
        const searchTermLast = ref("");
        const suggest = ref([]);
        const selector = ref(null);
        const form = ref();
        const formInput = ref();

        const setFocus = () => {
            if (props.opened) {
                window.setTimeout(() => {
                    formInput.value.focus();
                },150);
            }
        }

        watch(
            props,
            () => {
                setFocus();
            }
        )

        onMounted(() => {
            setFocus();
        });

        const selectSearch = (s) => {
            searchTerm.value = s;
            setTimeout(()=>{
                form.value.submit();
            },10);
        }

        const close = () => {
            emit("close")
        }

        const suggestUrl = new URL("/index.php", window.location.origin);

        let params = suggestUrl.searchParams;
        params.set("eID","keSearchPremiumAutoComplete")
        params.set("amount",10)
        params.set("pid",22)

        const request = () => {
            if (searchTerm.value.length > 2 && selector.value === null) {
                params.set("wordStartsWith",searchTerm.value);

                fetch(suggestUrl.href)
                    .then(r=>r.json())
                    .then(r=>{
                        if (r.length) {
                            suggest.value = r;
                        } else {
                            suggest.value = [];
                        }
                    })
            } else {
                suggest.value = [];
            }
        }

        const keyUp = () => {
            if (suggest.value.length) {
                if (selector.value === null) {
                    selector.value = suggest.value.length - 1;
                    searchTerm.value = suggest.value[selector.value];
                } else {
                    if ((selector.value - 1) < 0) {
                        selector.value = null;
                        searchTerm.value = searchTermLast.value;
                    } else {
                        selector.value--
                        searchTerm.value = suggest.value[selector.value];
                    }
                }
            } else {
                selector.value = null;
            }
        }

        const keyDown = () => {
            if (suggest.value.length) {
                if (selector.value === null) {
                    selector.value = 0;
                } else {
                    if ((selector.value + 1) >= suggest.value.length) {
                        selector.value = 0;
                    } else {
                        selector.value++
                    }
                }
                searchTerm.value = suggest.value[selector.value];
            } else {
                selector.value = null;
            }
        }

        const keyHandle = (e) => {
            if (e.key === "ArrowUp") {
                keyUp();
            } else if (e.key === "ArrowDown") {
                keyDown();
            } else if (e.key.length === 1 || e.key === "Backspace") {
                selector.value = null;
                searchTermLast.value = searchTerm.value;
                request();
            }
        }

        const suggestLabel = (text) => {
            let pattern = new RegExp(searchTermLast.value, "gi");
            let result = text.match(pattern);
            if (result) {
                result.forEach( r=> {
                    text = text.replace(r,'<span class="highlight">' + r + '</span>');
                })
            }
            return text;
        }

        window.addEventListener("click", () => {
            selector.value = null;
        })

        return {
            props,
            searchTerm,
            suggest,
            form,
            formInput,
            selector,
            close,
            selectSearch,
            keyHandle,
            suggestLabel
        }
    }
}
</script>

<style lang="scss">

@use "../scss/design-library/functions/calculate";
@use "../scss/design-library/typography";
@use "../scss/design-library/colors";
@use "../scss/design-library/grid";

.search-overlay {
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    z-index: 500;
    overflow: hidden;
    opacity: 0;
    transition: opacity linear .25s;
    pointer-events: none;

    @include grid.media-query_(mobile) {
        z-index: 1200;
    }
    &.active {
        opacity: 1;
        pointer-events: all;
    }

    &-headline {
        @include typography.headline2();
        color: #{colors.$white};
        text-align: center;
    }

    &__bg,
    &__content {
        position: absolute;
        top: 0;
        right: 0;
        left: 0;
        height: 100%;
    }

    &__bg {
        background-color: #{colors.$doehler-blue};
        opacity: .7;
    }

    &__content {
        margin-top: #{calculate.rem(85)};

        @include grid.media-query_up_("tablet_portrait") {
            margin-top: #{calculate.rem(110)};
        }

        &-grid {
            @include grid.layout-grid();
        }

        &-inner {
            @include grid.inner();
            justify-content: center;
        }

        &-cell {
            @include grid.cell();
            @include grid.cell-span_(4,tablet_portrait);
            @include grid.media-query_(tablet_portrait) {
                grid-column-start: 2;
            }
            @include grid.cell-span_(5,tablet_landscape);
            @include grid.media-query_(tablet_landscape) {
                grid-column-start: 3;
            }
            @include grid.cell-span_(6,desktop);
            @include grid.media-query_(desktop) {
                grid-column-start: 4;
            }
        }

        &-wrap {
            position: relative;
            width: #{calculate.rem(708)};
            max-width: 100%;
        }
    }

    &-form {
        position: relative;

        input {
            position: relative;
            z-index: 10;
            @include typography.body2();
            color: #{colors.$anthrazit};
            box-sizing: border-box;
            width: 100%;
            height: #{calculate.rem(48)};
            background-color: #{colors.$white};
            border: #{calculate.rem(1)} solid #{colors.$grey};
            border-radius: #{calculate.rem(30)};

            padding-right: #{calculate.rem(56)};
            padding-left: #{calculate.rem(21)};

            &:focus-visible {
                outline: none;
            }
        }

        button {
            z-index: 15;
            position: absolute;
            top: 0;
            right: 0;
            --mdc-text-button-with-icon-icon-size: #{calculate.rem(24)};
            padding: #{calculate.rem(12)} #{calculate.rem(16)}
        }
    }

    &__list {
        box-sizing: border-box;
        width: 100%;
        //max-height: #{calculate.rem(300)};
        overflow-x: hidden;
        overflow-y: auto;
        position:absolute;
        left: 0;
        top: #{calculate.rem(24)};
        margin: 0;
        padding: #{calculate.rem(48)} 0 #{calculate.rem(20)};
        background-color: #{colors.$white};
        display: none;
        border-radius: 0  0 #{calculate.rem(14)} #{calculate.rem(14)};
        box-shadow: 0px 20px 75px rgba(0, 0, 0, 0.1);

        &.open {
            display: block;
        }

        li {

            @include typography.body1();
            color: #{colors.$anthrazit};
            padding: #{calculate.rem(10)} #{calculate.rem(19)};
            cursor: pointer;

            &.active {
                background-color: #{colors.$light-grey};
            }

            .highlight {
                font-weight: 700;
                color: #{colors.$doehler-blue};
            }
        }
    }

    &-close {
        width: 100%;
        height: 0;
        position: relative;
        button {
            top: #{calculate.rem(-30)};
            left: calc(100% - 56px);
            --mdc-theme-primary: #{colors.$white};

            @include grid.media-query_up_(tablet_portrait) {
                left: calc(100% + #{calculate.rem(30)});
            }

            @include grid.media-query_up_(tablet_landscape) {
                left: calc(100% + #{calculate.rem(110)});
            }
        }
    }
}

</style>
